import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  // Autenticação própria (Etapa 3): e-mail + senha, sem serviço externo.
  // O backend devolve um token opaco de sessão; guardamos para o interceptor
  // de `lib/api.js` enviá-lo como Bearer nas próximas requisições.
  //
  // Com segundo fator ativo (Etapa P1b), a senha não abre sessão sozinha:
  // devolve um "desafio" de vida curta, que volta junto com os 6 dígitos.
  const guardarSessao = (data) => {
    if (data.session_token) localStorage.setItem('dpots_token', data.session_token);
    setUser(data.user);
    return data;
  };

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.requires_2fa) return { requires2fa: true, challenge: data.challenge };
    guardarSessao(data);
    return { requires2fa: false, user: data.user };
  }, []);

  const loginSegundoFator = useCallback(async (challenge, code) => {
    const { data } = await api.post('/auth/login/2fa', { challenge, code });
    return guardarSessao(data);
  }, []);

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('dpots_token');
    localStorage.removeItem('dpots_project_id');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, loginSegundoFator, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
